import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { APIResponse } from '@store/Shared/shared';

// ظظ

import { getTaskCommentByTaskId } from '../TaskComment/taskCommentSlice';
import { getTaskAssignmentsByTaskId } from '../TaskAssignment/taskAssignmentSlice';
import { getTaskTimeEntriesByTaskId } from '../TaskTimeEntrie/taskTimeEntrieSlice';
import { getTaskLinksByTaskId } from '../TaskLink/taskLinkSlice';
import { getTaskChangeRequestsByTaskId } from '../TaskChangeRequest/taskChangeRequestSlice';
import { getTaskDependenciesByTaskId } from '../TaskDependencie/taskDependencySlice';
// ظظ
export interface TaskModels {
  id: string;
  parentTaskId: string;
  name: string;
  name2: string;
  tags: string;
  description: string;
  assignedToName: string;
  assignedToName2: string;
  status: string;
  priority: string;
  startDate: string;
  dueDate: string;
  closedDate: string;
  estimatedHours: number;
  actualHours: number;
  assignedTo: string;
  ameStatus: number;
  isAme: true;
}
// ✅ إن رغبت بدعم rollback لاحقًا، فعّل المخزن المؤقت (اختياري):
type StatusMap = Record<string, string | undefined>;

// 🔹 Thunk مركزي لجلب جميع بيانات تبويبات المهمة
export const loadTaskAllTabs = createAsyncThunk(
  'Task/loadTaskAllTabs',
  async (taskId: string, { dispatch, rejectWithValue }) => {
    try {
      await Promise.all([
        dispatch(getTaskCommentByTaskId(taskId)),
        dispatch(getTaskAssignmentsByTaskId(taskId)),
        dispatch(getTaskTimeEntriesByTaskId(taskId)),
        dispatch(getTaskLinksByTaskId(taskId)),
        dispatch(getTaskChangeRequestsByTaskId(taskId)),
        dispatch(getTaskDependenciesByTaskId(taskId))
      ]);

      return { succeeded: true, taskId };
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const addTasks = createAsyncThunk('Tasks/addTasks', async (item: any, { rejectWithValue }) => {
  try {
    const { data } = await ntxAPI.post<APIResponse<string>>('Task/AddTasks', item);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const updateTasks = createAsyncThunk('Tasks/updateTasks', async (item: any, { rejectWithValue }) => {
  try {
    const { data } = await ntxAPI.post('Task/UpdateTasks', item);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const getTasksList = createAsyncThunk('Tasks/getTasksList', async (_, { rejectWithValue }) => {
  try {
    const { data } = await ntxAPI.get(`Task/GetTasksList`);
    if (data.succeeded === true) {
      return data.data;
    } else {
      return [];
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const getTasksById = createAsyncThunk('Tasks/GetTasksById', async (id: string, { rejectWithValue }) => {
  try {
    const { data } = await ntxAPI.get(`Task/GetTasksById?id=${id}`);
    if (data.succeeded === true) {
      return data.data;
    } else {
      return [];
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const setTaskStatus = createAsyncThunk('Tasks/setTaskStatus', async (item: any, { rejectWithValue }) => {
  try {
    const { data } = await ntxAPI.post<APIResponse<string>>('Task/SetTaskStatus', item);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

const initialState: {
  TasksList: TaskModels[];
  PreviousTasksList: TaskModels[];
  loading: boolean;
  error: any | null;
  //
  TasksById: TaskModels;
  loading2: boolean;
  error2: any | null;

  // اختياري: لحفظ الحالة السابقة أثناء الطلب (للـ rollback)
  _prevStatuses?: StatusMap;
} = {
  TasksList: [],
  PreviousTasksList: [],
  loading: false,
  error: null,
  TasksById: {} as TaskModels,
  loading2: false,
  error2: null,
  //
  _prevStatuses: {}
};

const TaskSlice = createSlice({
  name: 'Tasks',
  initialState,
  reducers: {
    updateTaskStatusInList: (state, action: PayloadAction<{ taskId: string; status: string }>) => {
      const { taskId, status } = action.payload;
      const idx = state.TasksList.findIndex(t => String(t.id) === String(taskId));
      if (idx !== -1) {
        state.TasksList[idx] = { ...state.TasksList[idx], status: status };
      }
    },
    rollbackTaskStatus: state => {
      state.TasksList = state.PreviousTasksList;
    }
  },
  extraReducers(builder) {
    builder

      .addCase(getTasksList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getTasksList.fulfilled, (state, action: PayloadAction<TaskModels[]>) => {
        state.loading = false;
        state.TasksList = action.payload;
        state.PreviousTasksList = action.payload;
      })
      .addCase(getTasksList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getTasksById.pending, (state, action) => {
        state.loading2 = true;
        state.error2 = null;
      })
      .addCase(getTasksById.fulfilled, (state, action: PayloadAction<TaskModels>) => {
        state.loading2 = false;
        state.TasksById = action.payload;
      })
      .addCase(getTasksById.rejected, (state, action: PayloadAction<any>) => {
        state.loading2 = false;
        state.error2 = action.payload;
      });
  }
});

export const { updateTaskStatusInList , rollbackTaskStatus } = TaskSlice.actions;
export default TaskSlice.reducer;
